<template>
  <div class="home-container">
    <NavBar :data="navbarData" />
    <router-view></router-view>
    <Footer />
    <ScrollTop />
  </div>
</template>
<script>
//v-wechat-title="$route.meta.title"
import { mapGetters } from "vuex";
// import { Notification } from "element-ui";
import { formatMsgTimeStamp } from "../js/chat";
import NavBar from "../components/NavBar";
import Footer from "../components/Footer";
import { apiMap } from "../utils/apiMap";
import ScrollTop from "../components/scrollTop";
import qs from "qs";
export default {
  name: "home",
  data() {
    return {
      navbarData: [
        { title: "联系", type: "0", path: "/contacts" },
        { title: "社区", type: "0", path: "/community" },
        { title: "小区", type: "0", path: "/feeds" },
        { title: "我的", type: "1", path: "/users" },
      ],
    };
  },
  components: {
    NavBar,
    Footer,
    ScrollTop,
  },
  computed: {
    ...mapGetters(["user", "adminNotice"]),
  },
  beforeMount() {
    this.navbarData[3].path = `/feed?id=${this.user.userId}`;
  },
  mounted() {
    this.resetListener();
    this.getFriendList();
    this.initListener();
    let userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
    let tim = this.$store.state.timInstance;
    //let TIM = this.$store.state.timNamespace;
    let promise = tim.login({
      userID: userInfo.userId.toString(),
      userSig: userInfo.imUserSign,
    });
    let _this = this;
    promise
      .then(function(imResponse) {
        console.log("登录成功"); // 登录成功
        // getGroupList();
        _this.sendLoginSuccessMsg();
      })
      .catch(function(imError) {
        console.warn("login error:", imError); // 登录失败的相关信息
      });

    this.getUserProfile();
    this.getUserPermission();
    window.addEventListener("beforeunload", (e) => this.beforeunloadFn(e));
  },
  methods: {
    initListener() {
      // 登录成功后会触发 SDK_READY 事件，该事件触发后，可正常使用 SDK 接口
      // this.tim.on(this.TIM.EVENT.SDK_READY, this.onReadyStateUpdate, this)
      // SDK NOT READT
      // this.tim.on(this.TIM.EVENT.SDK_NOT_READY, this.onReadyStateUpdate, this)
      // 被踢出
      this.tim.on(this.TIM.EVENT.KICKED_OUT, this.onKickOut);
      // SDK内部出错
      // this.tim.on(this.TIM.EVENT.ERROR, this.onError)
      // 收到新消息
      this.tim.on(this.TIM.EVENT.MESSAGE_RECEIVED, this.onReceiveMessage);
      // 会话列表更新
      this.tim.on(
        this.TIM.EVENT.CONVERSATION_LIST_UPDATED,
        this.onUpdateConversationList
      );
      // 群组列表更新
      this.tim.on(this.TIM.EVENT.GROUP_LIST_UPDATED, this.onUpdateGroupList);
      // 收到新的群系统通知
      this.tim.on(
        this.TIM.EVENT.GROUP_SYSTEM_NOTICE_RECEIVED,
        this.onReceiveGroupSystemNotice
      );
    },
    resetListener() {
      this.tim.off(this.TIM.EVENT.MESSAGE_RECEIVED, this.onReceiveMessage);
      // 会话列表更新
      this.tim.off(
        this.TIM.EVENT.CONVERSATION_LIST_UPDATED,
        this.onUpdateConversationList
      );
      // 群组列表更新
      this.tim.off(this.TIM.EVENT.GROUP_LIST_UPDATED, this.onUpdateGroupList);
      // 收到新的群系统通知
      this.tim.off(
        this.TIM.EVENT.GROUP_SYSTEM_NOTICE_RECEIVED,
        this.onReceiveGroupSystemNotice
      );
    },
    onUpdateGroupList({ data: groupList }) {
      let newList = groupList.map((item) => {
        item.avatar = this.$store.state.defaultAvatar.GROUP;
        return item;
      });
      this.$store.dispatch("setGroupList", newList);
    },
    onReceiveMessage({ data: messageList }) {
      let currentConversation = Store.getters.currentConversation;
      // let conversationList = Store.getters.conversationList;
      let adminMsgs = [];
      // console.log("收到新消息", messageList);
      messageList.forEach((item) => {
        if (item.conversationID === currentConversation.conversationID) {
          Store.dispatch("pushCurrentMessageList", item);
        }
        //[0].from [0].payload.data
        if (item.from == "admin") {
          switch (item.payload.data) {
            case "168":
              //强制下线消息
              this.executeLogoutMsg();
              break;
            case "101":
              //手机端上线消息
              this.sendOnlineMsg();
              let msgItem = {
                content: item.payload.extension,
                time: item.time,
                type: item.payload.data,
              };
              adminMsgs.push(msgItem);
              break;
            case "120":
              //分组变化消息
              this.getFriendList();
              break;
          }
        }
      });
      if (adminMsgs.length > 0) {
        this.$store.dispatch("pushAdminNotice", adminMsgs);
      }
    },
    onUpdateConversationList({ data: conversationList }) {
      this.initConversationList(conversationList);
      // let promise = tim.getConversationList();
      // promise.then(function(imResponse) {
      //   const conversationList = imResponse.data.conversationList; // 会话列表，用该列表覆盖原有的会话列表
      // }).catch(function(imError) {
      //   console.warn('getConversationList error:', imError); // 获取会话列表失败的相关信息
      // });
    },
    onReceiveGroupSystemNotice(event) {
      let currentConversation = Store.getters.currentConversation;
      const isKickedout = event.data.type === 4;
      const isCurrentConversation =
        `GROUP${event.data.message.payload.groupProfile.groupID}` ===
        currentConversation.conversationID;
      // 在当前会话被踢，需reset当前会话
      if (isKickedout && isCurrentConversation) {
        this.$store.dispatch("resetCurrentConversation");
      }
      // Notification({
      //   title: '新系统通知',
      //   message: translateGroupSystemNotice(event.data.message),
      //   duration: 15000,
      //   onClick: () => {
      //     const SystemConversationID = '@TIM#SYSTEM'
      //     this.$store.dispatch('checkoutConversation', SystemConversationID)
      //   }
      // })
    },
    getFriendList() {
      let loginUser = JSON.parse(sessionStorage.getItem("userInfo"));
      this.$axios({
        baseURL: apiMap["commonUrl"],
        method: apiMap["friendsList"]["method"],
        url: apiMap["friendsList"]["url"],
        data: "token=" + loginUser.token,
      })
        .then(function(response) {
          // console.log(response.data);
          if (response.data.result.statusCode == 1) {
            let newList = response.data.result.data.filter((item) => {
              return item.userId != loginUser.userId;
            });
            let friendGroup = ["朋友"];
            let contactList = new Array();
            let contactBook = new Array();
            newList.forEach((item) => {
              let remark = "";
              let displayHeadImg = Store.state.defaultAvatar.C2C;
              var groupIndex = friendGroup.indexOf(item.group);
              if (groupIndex == -1 && item.group != "null") {
                friendGroup.push(item.group);
              }
              if (item.group == "null") {
                item.group = "朋友";
              }
              if (item.thumbHeadImg) {
                displayHeadImg = item.thumbHeadImg;
              } else if (item.headImgUrl) {
                displayHeadImg = item.headImgUrl;
              }
              if (item.markInfo) {
                remark = item.markInfo.mark;
              }
              item.avatar = displayHeadImg;
              item.remark = remark;
              contactList.push(item);
            });
            friendGroup.forEach((element) => {
              let item = {
                name: element,
                member: contactList.filter((friend) => friend.group == element),
              };
              contactBook.push(item);
            });
            Store.dispatch("setContactList", contactList);
            Store.dispatch("setFriendGroup", friendGroup);
            Store.dispatch("setContactBook", contactBook);
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    doneClick() {
      this.$store.dispatch("setDone");
    },
    initConversationList(list) {
      if (Array.isArray(list)) {
        let C2CAvatar = this.$store.state.defaultAvatar.C2C;
        let groupAvatar = this.$store.state.defaultAvatar.GROUP;
        let myContacts = this.$store.getters.contactsList;
        // console.log(myContacts);

        let session = [];
        let adminMsgs = [];
        for (let index = 0; index < list.length; index++) {
          const item = list[index];

          if (item.conversationID == "C2Cadmin") {
            //过滤管理员消息
            //168-强制退出消息
            //500-PC退出消息
            //502-PC在线消息
            var filterArr = ["168", "500", "502"];
            if (filterArr.includes(item.lastMessage.payload.data)) {
              continue;
            } else {
              let msgItem = {
                content: item.lastMessage.payload.extension,
                time: item.lastMessage.lastTime,
                type: item.lastMessage.payload.data,
              };
              adminMsgs.push(msgItem);
            }
          } else {
            let messageForShow = this.initMessageForShow(item);
            switch (item.type) {
              case "C2C":
                let thisFriend = myContacts.filter((contact) => {
                  return contact.userId == item.userProfile.userID;
                });
                let displayName = item.userProfile.nick;
                let displayHeadImg = item.userProfile.avatar;
                if (thisFriend.length != 0) {
                  displayHeadImg = thisFriend[0].avatar;
                  if (
                    thisFriend[0].markInfo &&
                    thisFriend[0].markInfo.mark != ""
                  ) {
                    displayName = thisFriend[0].markInfo.mark;
                  } else {
                    displayName = thisFriend[0].name;
                  }
                }
                session.push({
                  avatar: displayHeadImg || C2CAvatar,
                  name: displayName,
                  lastMessage: messageForShow,
                  lastTime: formatMsgTimeStamp(item.lastMessage.lastTime),
                  sessionId: item.conversationID,
                  type: item.type,
                  unreadCount: item.unreadCount,
                  userId: item.userProfile.userID,
                });
                break;
              case "GROUP":
                session.push({
                  avatar: groupAvatar,
                  name: item.groupProfile.name,
                  lastMessage: messageForShow,
                  lastTime: formatMsgTimeStamp(item.lastMessage.lastTime),
                  sessionId: item.conversationID,
                  type: item.type,
                  unreadCount: item.unreadCount,
                  userId: item.groupProfile.groupID,
                });
                break;
              default:
                break;
            }
          }
        }
        this.$store.dispatch("setConversationList", session);
        if (adminMsgs.length > 0) {
          this.$store.dispatch("pushAdminNotice", adminMsgs);
        }
      }
    },
    initAdminNotice(message) {
      // let customPayload = message.payload.extension.replace(/'/g, '"');
      // try{
      //   customPayload = JSON.parse(customPayload)
      // } catch(e) {
      //   customPayload = ""
      // }
      // message.payload.extension = customPayload;
      //let msgItem = {
      //   content: item.lastMessage.payload.extension,
      //   time: item.lastMessage.lastTime,
      //   type: item.lastMessage.payload.data,
      // }
      //  this.$store.dispatch("pushAdminNotice",message);
    },
    initMessageForShow(message) {
      if (message.lastMessage.isRevoked) {
        let userProfile = this.$store.getters.user;
        if (userProfile && userProfile.userId) {
          if (
            message.lastMessage.fromAccount === userProfile.userId.toString()
          ) {
            return "您撤回了一条消息";
          }
        }
        if (message.type === TIM.TYPES.CONV_C2C) {
          return "对方撤回了一条消息";
        }
        let contactInfo = this.$store.getters.contactsList.filter(
          (item) => item.userId.toString() == message.lastMessage.fromAccount
        );
        if (contactInfo.length != 0) {
          if (contactInfo[0].remark != "") {
            return `${contactInfo[0].remark}撤回了一条消息`;
          } else {
            return `${contactInfo[0].name}撤回了一条消息`;
          }
        } else {
          return `群成员撤回了一条消息`;
        }
      } else if (message.lastMessage.type === TIM.TYPES.MSG_CUSTOM) {
        switch (message.lastMessage.payload.data) {
          case "304":
            return `[文章分享]`;
          case "320":
            return `[相册分享]`;
          case "336":
            return `[音频分享]`;
          case "352":
            return `[视频分享]`;
          default:
            return message.lastMessage.payload.description;
        }
      }
      return message.lastMessage.messageForShow;
    },
    getUserProfile() {
      let loginUser = JSON.parse(sessionStorage.getItem("userInfo"));
      this.$axios({
        baseURL: apiMap["commonUrl"],
        method: apiMap["getProfile"]["method"],
        url: apiMap["getProfile"]["url"],
        data: `token=${loginUser.token}`,
      })
        .then(function(response) {
          if (response.data.result.statusCode == 1) {
            let userProfile = response.data.result.data;
            if (!userProfile.headImgUrl) {
              userProfile.avatar = Store.state.defaultAvatar.C2C;
            } else {
              userProfile.avatar = userProfile.headImgUrl;
            }
            Store.dispatch("setUserProfile", userProfile);
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    getUserPermission() {
      let _this = this;
      let loginUser = JSON.parse(sessionStorage.getItem("userInfo"));
      _this
        .$axios({
          baseURL: apiMap["commonUrl"],
          method: apiMap["userPermission"]["method"],
          url: apiMap["userPermission"]["url"],
          data: `token=${loginUser.token}`,
        })
        .then(function(response) {
          // console.log(response.data.result.data);
          if (response.data.result.statusCode == 1) {
            Store.dispatch("setUserPermission", response.data.result.data);
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    executeLogoutMsg() {
      sessionStorage.setItem("LOGOUT", "android");
      setTimeout(() => {
        Router.push("/login");
      }, 700);
    },
    sendOnlineMsg() {
      let _this = this;
      let loginUser = JSON.parse(sessionStorage.getItem("userInfo"));
      let paramArr = [
        `token=${loginUser.token}`,
        `userId=${loginUser.userId}`,
        `title=您的帐号于电脑端在线`,
        `content=""`,
        `msgType=502`,
      ];
      //`content=${Date.now()}`,
      _this
        .$axios({
          baseURL: apiMap["commonUrl"],
          method: apiMap["sendAdminMsg"]["method"],
          url: apiMap["sendAdminMsg"]["url"],
          data: paramArr.join("&"),
        })
        .then(function(response) {
          // console.log(response.data);
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    onKickOut() {
      const h = this.$createElement;
      this.$msgbox({
        title: "【传联提示】",
        message: h("div", null, [
          h("p", null, "您的帐号已在其他终端登录，当前设备已下线"),
          h("p", null, "若非本人操作，密码可能已泄露，请修改密码"),
        ]),
        showClose: false,
        showCancelButton: false,
        closeOnClickModal: false,
        confirmButtonText: "确定",
        beforeClose: (action, instance, done) => {
          done();
          this.$store.dispatch("resetConversationList");
          this.$store.dispatch("setContactBook");
          this.$store.dispatch("pushAdminNotice");
          sessionStorage.clear();
          localStorage.clear();
          this.$router.push("/login");
        },
      })
        .then(() => {})
        .catch(() => {});
    },
    sendLoginSuccessMsg() {
      let _this = this;
      let loginUser = JSON.parse(sessionStorage.getItem("userInfo"));
      var params = {
        token: loginUser.token,
        userId: loginUser.userId.toString(),
        title: "您的帐号于电脑端在线",
        content: "",
        msgType: "502",
      };
      //content: Date.now(),
      _this
        .$axios({
          baseURL: apiMap["commonUrl"],
          method: apiMap["sendAdminMsg"]["method"],
          url: apiMap["sendAdminMsg"]["url"],
          data: qs.stringify(params, { encode: false }),
        })
        .then(function(response) {
          // console.log(response.data.result.data);
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    beforeunloadFn(e) {
      console.log(e);
      this.sendLogoutSuccessMsg();
    },
    sendLogoutSuccessMsg() {
      let _this = this;
      let loginUser = JSON.parse(sessionStorage.getItem("userInfo"));
      var params = {
        token: loginUser.token,
        userId: loginUser.userId.toString(),
        title: "您的帐号在电脑端退出",
        content: "",
        msgType: "500",
      };
      //content: Date.now(),
      _this
        .$axios({
          baseURL: apiMap["commonUrl"],
          method: apiMap["sendAdminMsg"]["method"],
          url: apiMap["sendAdminMsg"]["url"],
          data: qs.stringify(params, { encode: false }),
        })
        .then(function(response) {
          // console.log(response.data.result.data);
        })
        .catch(function(error) {
          console.log(error);
        });
    },
  },
  destroyed() {
    window.removeEventListener("beforeunload", (e) => this.beforeunloadFn(e));
  },
};
</script>
<style scoped>
.home-container .header-wrapper {
  position: fixed;
  width: 100%;
  left: 0;
  top: 0;
  z-index: 2000;
  background-color: #ffffff;
  border-bottom: solid 1px #e6e6e6;
}

.home-container .home-child-wrapper {
  width: 1200px;
  min-height: 900px;
  margin: 0 auto;
  padding-top: 82px;
  box-sizing: border-box;
}

.home-container .community-container {
  padding-top: 60px;
}
</style>
